import classnames from 'classnames';
import React from 'react';

import { Button } from '@flixbus/honeycomb-react';

import { FEEDBACK_TEXT } from './text';

import styles from './styles.module.css';

const MAINTENANCE_END_MS = Date.UTC(2026, 8, 3, 20, 0);

const FeedbackBanner = () => {
	if (Date.now() < MAINTENANCE_END_MS) {
		return (
			<div className={classnames(styles.bricks, styles.maintenance)}>
				<div className={styles.important}>
					<span aria-hidden="true">⚠️</span>
					<span className={styles.bold}>Important!</span>
				</div>
				<div>
					Scheduled maintenance on <span className={styles.bold}>September 3 at 19:00 UTC</span> (
					<span className={styles.bold}>2:00 PM Dallas / 12:30 AM IST next day</span>). Dispatch may
					be unavailable for a few minutes (up to ~15 min)
				</div>
			</div>
		);
	}

	return (
		<div className={styles.bricks}>
			<div className={styles.bold}>📣 {FEEDBACK_TEXT.helpTitle}</div>
			<div>{FEEDBACK_TEXT.suggestion}</div>
			<Button size="sm">{FEEDBACK_TEXT.leaveFeedback}</Button>
		</div>
	);
};

export default FeedbackBanner;
